export default {
  headerContent: {
    title: 'HDI Sigorta Ferdi Kaza Sigortası Fiyatları',
    slogan: "Ferdi Kaza Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'FERDİ KAZA SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'HDI Sigorta Ferdi Kaza Sigortası',
    description: {
      title: 'HDI Sigorta Ferdi Kaza Sigortası Nedir?',
      content: [
        '<strong>HDI Sigorta ferdi kaza sigortası</strong> beklenmedik ve ani gelişen kazalara karşı güvence veren sigorta türüdür. Sigorta kapsamında meydana gelebilecek kaza durumlarına karşılık, HDI Sigorta tazminat ödemesinde bulunur. Böylece herhangi bir durum neticesinde oluşan maddi kayıplar önlenir.',
        'Ferdi kaza sigortası, sizi ve ailenizi bir kazanın maddi acısına karşı korur. Kaza nedeniyle meydana gelen ölüm, kalıcı / geçici sakatlık ve hastanede kalmayı kapsayan sabit bir fayda planıdır. Bu talihsiz olaylardan herhangi birinin olması durumunda, plan, poliçe hüküm ve koşullarında belirtildiği gibi toplu bir ödeme sağlar.'
      ]
    },
    subContent: {
      title: 'HDI Sigorta ferdi kaza sigortası',
      content: [
        {
          paragraph:
            'HDI Sigorta ferdi kaza sigortası geniş bir alanda teminatlar sunmaktadır. ',
          subList: null
        },
        {
          paragraph:
            'Sık karşılaşılan trafik, iş ve ev kazalarının yanı sıra ısırılma, kırık – çıkık, zehirli gazların solunması sonucu oluşan hasar gibi durumlar kapsam içindedir. Böylece sigortalı kişinin ilgili kazalarda yaşadığı sorunlara maddi kolaylık sağlanmaktadır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Ferdi Kaza Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'HDI Sigorta Ferdi Kaza Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
